var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreedot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.98693C0 1.37691 0.172656 0.897603 0.517968 0.54902C0.863281 0.183007 1.31846 0 1.88352 0C2.47997 0 2.95085 0.183007 3.29616 0.54902C3.64147 0.897603 3.81413 1.37691 3.81413 1.98693C3.81413 2.59695 3.64147 3.08497 3.29616 3.45098C2.95085 3.81699 2.47997 4 1.88352 4C1.31846 4 0.863281 3.81699 0.517968 3.45098C0.172656 3.08497 0 2.59695 0 1.98693Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09293 1.98693C6.09293 1.37691 6.26559 0.897603 6.6109 0.54902C6.95621 0.183007 7.4114 0 7.97646 0C8.5729 0 9.04378 0.183007 9.3891 0.54902C9.73441 0.897603 9.90707 1.37691 9.90707 1.98693C9.90707 2.59695 9.73441 3.08497 9.3891 3.45098C9.04378 3.81699 8.5729 4 7.97646 4C7.4114 4 6.95621 3.81699 6.6109 3.45098C6.26559 3.08497 6.09293 2.59695 6.09293 1.98693Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1859 1.98693C12.1859 1.37691 12.3585 0.897603 12.7038 0.54902C13.0491 0.183007 13.5043 0 14.0694 0C14.6658 0 15.1367 0.183007 15.482 0.54902C15.8273 0.897603 16 1.37691 16 1.98693C16 2.59695 15.8273 3.08497 15.482 3.45098C15.1367 3.81699 14.6658 4 14.0694 4C13.5043 4 13.0491 3.81699 12.7038 3.45098C12.3585 3.08497 12.1859 2.59695 12.1859 1.98693Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/threedot.a04708a67f7c1e28ad082eb20544035f.svg";
export { ForwardRef as ReactComponent };